module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Redo_16"],"path":[{"$":{"d":"M0,15S.58,9.8,10,9.8V13l6-5L10,3V6.2C2.75,6.2,0,9.34,0,15Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Redo_16.svg
// module id = 9dZ9
// module chunks = 1